import type { RenderLoader, CreateStartOptions } from '../types'

interface Options extends CreateStartOptions { }

export default function lazyMicroservices(renderLoader: RenderLoader, mountPointId: string, options: Options) {
  let preventLoading = false

  const fn = async () => {
    if (preventLoading) {
      return
    }

    preventLoading = true

    await (await options.lazyStoreManagerLoader()).initializing

    const renderer = renderLoader()

    let mountPoint = document.getElementById(mountPointId)

    if (!mountPoint) {
      mountPoint = document.createElement('div')
      mountPoint.id = mountPointId
      document.body.appendChild(mountPoint)
    }

    (await renderer).render(mountPoint)
  }

  if (localStorage.getItem('_ms_lazyloaded') === 'true') {
    fn()
  } else {
    window.addEventListener('mousemove', load)
    window.addEventListener('touchstart', load)
    window.addEventListener('scroll', load)

    window.document.addEventListener('click', handleClick, { capture: true })
    window.document.addEventListener('click', handleLinkClick, { capture: true })
  }

  async function load() {
    window.removeEventListener('mousemove', load)
    window.removeEventListener('touchstart', load)
    window.removeEventListener('scroll', load)

    localStorage.setItem('_ms_lazyloaded', 'true')

    await fn()
  }

  async function waitCheckRequest(callback: () => void) {
    const start = Date.now()

    const waitCheckRequestIntetval = setInterval(async () => {
      if ((window as any).checkAuthData) {
        clearInterval(waitCheckRequestIntetval)
        try {
          await (window as any).checkAuthData
        } catch (err) {
          console.error(err)
        } finally {
          callback()
        }
      } else if (Date.now() - start >= 5000) { // fallback after 5 seconds for users with slow internet and no checkAuthData
        clearInterval(waitCheckRequestIntetval)
        callback()
      }
    }, 50)
  }

  async function handleClick(e: Event) {
    if (localStorage.getItem('_ms_lazyloaded') === 'true' && !preventLoading) {
      window.document.removeEventListener('click', handleClick, { capture: true })
      return
    }

    let target = e.target as HTMLElement

    while (target && target?.dataset?.openAuthModal !== 'true') {
      target = target.parentNode as HTMLElement
    }

    if (!target) {
      return
    }

    window.document.removeEventListener('click', handleClick, { capture: true })

    await load()

    await waitCheckRequest(target.click.bind(target))
  }

  async function handleLinkClick(e: Event) {
    if (localStorage.getItem('_ms_lazyloaded') === 'true' && !preventLoading) {
      window.document.removeEventListener('click', handleLinkClick, { capture: true })
      return
    }

    const target = (e.target as HTMLElement)?.closest('a[href]') as HTMLAnchorElement | null
    if (!target) return
    if (target.href.startsWith('mailto:')) return
    if (target.href.startsWith('tel:')) return

    window.document.removeEventListener('click', handleLinkClick, { capture: true })
    e.preventDefault()

    await load()

    await waitCheckRequest(() => {
      window.location.href = target.href
    })
  }
}
